import {isFiniteNullableNumber} from './isFiniteNullableNumber';

/**
 * 将可空数字保留到小数点后 8 位。
 * @param value 输入数字；为空或非有限数字时返回 null。
 * @returns 保留 8 位小数后的数字，或 null。
 */
export function roundNullableToEightDecimalPlaces(value: number | null | undefined): number | null {
    if (!isFiniteNullableNumber(value)) {
        return null;
    }
    return Number(value.toFixed(8));
}
